(function () {
  // Tile videos are rendered with preload="none" and no autoplay attribute (see
  // usp-carousel.liquid), so nothing is fetched until the tile is actually on screen.
  const playVideo = (video) => {
    video.muted = true; // Safari ignores the attribute on some paths; the property is what counts
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {});
    }
  };

  const setupVideoAutoplay = (section) => {
    const videos = section.querySelectorAll(
      "video[data-usp-autoplay]:not([data-usp-observed])"
    );
    if (!videos.length) return;

    if (!("IntersectionObserver" in window)) {
      videos.forEach(playVideo);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            playVideo(entry.target);
          } else if (!entry.target.paused) {
            entry.target.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    videos.forEach((video) => {
      video.dataset.uspObserved = "true";
      observer.observe(video);
    });
  };

  const initUspCarousel = (root = document) => {
    root.querySelectorAll(".js-usp-carousel-section").forEach((section) => {
      setupVideoAutoplay(section);

      const carousel = section.querySelector(".js-swiper-usp-carousel");
      const scrollBar = section.querySelector(".js-usp-carousel-swiper-scrollbar");
      const prev = section.querySelector(".js-usp-carousel-arrow-prev");
      const next = section.querySelector(".js-usp-carousel-arrow-next");
      const navTools = section.querySelector(".product-carousel_nav-tools");

      if (!carousel || typeof Swiper === "undefined") return;

      const getCardsToShow = (value, fallback) => {
        const cardsToShow = Number(value);
        return Number.isFinite(cardsToShow) && cardsToShow > 0
          ? cardsToShow
          : fallback;
      };

      const mobileCardsToShow = getCardsToShow(section.dataset.mobileCards, 2);
      const tabletCardsToShow = getCardsToShow(section.dataset.tabletCards, 3);
      const desktopCardsToShow = getCardsToShow(section.dataset.desktopCards, 4);

      if (carousel.swiper) {
        carousel.swiper.destroy(true, true);
      }

      const updateNavTools = (swiper) => {
        if (!navTools) return;
        navTools.style.display = swiper && swiper.isLocked ? "none" : "";
      };

      const swiperCarousel = new Swiper(carousel, {
        slidesPerView: mobileCardsToShow,
        spaceBetween: 20,
        slidesOffsetAfter: 0,
        watchOverflow: true,
        scrollbar: {
          el: scrollBar,
          draggable: true,
        },
        navigation: {
          prevEl: prev,
          nextEl: next,
        },
        breakpoints: {
          750: {
            slidesPerView: tabletCardsToShow,
            spaceBetween: 20,
            slidesOffsetAfter: 0,
          },
          990: {
            slidesPerView: desktopCardsToShow,
            spaceBetween: 24,
            slidesOffsetAfter: 0,
          },
          1100: {
            slidesPerView: desktopCardsToShow,
            spaceBetween: 24,
            slidesOffsetAfter: 0,
          },
        },
        on: {
          init: updateNavTools,
          lock: updateNavTools,
          unlock: updateNavTools,
          resize: updateNavTools,
        },
      });

      updateNavTools(swiperCarousel);
    });
  };

  const onReady = () => {
    initUspCarousel();

    document.addEventListener("shopify:section:load", function (event) {
      initUspCarousel(event.target);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }
})();
